import {
  FaDraftingCompass,
  FaHome,
  FaRegBuilding,
  FaTools,
  FaPalette,
} from "react-icons/fa";
import { GiSmartphone, GiBrickWall, GiEnergyArrow, GiSofa } from "react-icons/gi";
import { MdOutlineChair } from "react-icons/md";

export const stats = [
  { label: "Years Of Excellence", value: "12+" },
  { label: "Turnkey Projects", value: "650+" },
  { label: "Specialist Team", value: "50+" },
  { label: "Partner Brands", value: "30+" },
];

export const heroHighlights = [
  "Interior Designing in Delhi",
  "Residential Turnkey Construction",
  "Commercial Construction",
  "Home Renovation Experts",
  "Modern Kitchen & Wardrobe Design",
];

export const services = [
  {
    title: "Architectural Design",
    description:
      "Concept-to-blueprint architectural planning, approvals, 3D visualization, and structural coordination for homes and commercial spaces.",
    icon: FaDraftingCompass,
    image: "/images/architectural-design.webp",
    highlights: [
      "Architectural drawings & BIM-ready plans",
      "Regulatory approvals & structural liaison",
      "3D exterior elevations and walkthroughs",
    ],
  },
  {
    title: "Residential Construction",
    description:
      "End-to-end villa, bungalow, duplex, and independent floor construction with premium materials and site supervision.",
    icon: FaHome,
    image: "/images/building-constructions.webp",
    highlights: [
      "Custom layouts & vastu-aligned planning",
      "Civil, MEP, and finishing under one roof",
      "Site safety and weekly progress audits",
    ],
  },
  {
    title: "Residential Interiors",
    description:
      "Turnkey interiors for bedrooms, living rooms, kitchens, and dining spaces tailored to lifestyle, storage, and aesthetic goals.",
    icon: GiSofa,
    image: "/images/interiors.webp",
    highlights: [
      "Modular kitchens & wardrobe systems",
      "False ceilings, lighting & flooring",
      "Premium finishes and bespoke furniture",
    ],
  },
  {
    title: "Commercial Interiors",
    description:
      "High-impact interiors for offices, retail, hospitality, salons, clinics, showrooms, and co-working environments.",
    icon: FaRegBuilding,
    highlights: [
      "Brand-aligned design strategy",
      "Acoustic, lighting & HVAC integration",
      "Fast-track execution timelines",
    ],
  },
  {
    title: "Renovation & Remodeling",
    description:
      "Transform existing spaces with structural upgrades, damp-proofing, layout optimization, and finish refresh.",
    icon: FaTools,
    image: "/images/renovation-remodeling.webp",
    highlights: [
      "Structural rework & expansion",
      "Bathroom, kitchen & facade upgrades",
      "Waterproofing and damp treatment",
    ],
  },
  {
    title: "Home Automation",
    description:
      "Smart lighting, climate control, security, and voice-enabled solutions integrated with modern interiors.",
    icon: GiSmartphone,
    highlights: [
      "App & voice-controlled experience",
      "Security, CCTV & access integration",
      "Energy monitoring and automation",
    ],
  },
];

export const brandTechnologies = ["AutoCAD", "Photoshop", "3ds Max", "Autodesk", "SketchUp"];

export const brandPartners = [
  "Hafele",
  "Havells",
  "Century Ply",
  "Finolex",
  "GM Modular",
  "Godrej",
  "Dorset",
  "Astral Pipes",
  "Polycab",
  "Kajaria",
  "Asian Paints",
  "Indigo Paints",
  "Action Tesa",
  "Somany",
  "Hindware",
  "Mitsubishi",
  "Hettich",
  "Ultratech Cement",
  "Legrand",
  "Tata Steel",
  "Syska",
];

export const roadmap = [
  {
    year: "2013",
    title: "From IT to Infrastructure",
    description:
      "Began as CST IT Firm, collaborating with architects and transitioning into construction by founding Karthikeya Constructions.",
  },
  {
    year: "2015",
    title: "Mastering Turnkey Construction",
    description:
      "Assembled architects, engineers, and project managers to deliver turnkey residential and commercial projects with precision.",
  },
  {
    year: "2021",
    title: "Evolution Into Interior Design",
    description:
      "Expanded into interiors to offer end-to-end solutions from architectural planning to finishing and styling.",
  },
  {
    year: "Today",
    title: "Designing Dreams, Building Excellence",
    description:
      "Delivering innovative construction and interior projects that balance aesthetics, functionality, and longevity.",
  },
];

export const projectShowcase = [
  {
    title: "Skyview Residences – Tower B",
    description:
      "26-storey RCC superstructure with PT slabs, shear-wall cores, and façade brackets cast in a single cycle for faster elevations.",
    image: "/images/construction-premium.avif",
    category: "Residential Superstructure",
  },
  {
    title: "Innovation Tech Park Podium",
    description:
      "Five-acre corporate podium with composite columns, fire-rated shafts, and MEP decks coordinated through BIM and laser layout.",
    image: "/images/construction-site-1.avif",
    category: "Commercial & Corporate",
  },
  {
    title: "Eastern Logistics Hub",
    description:
      "PEB + RCC hybrid warehouse with 32-meter clear spans, insulated roofing, and FM-approved floor flatness for AGV movement.",
    image: "/images/construction-site-2.avif",
    category: "Industrial & Warehousing",
  },
  {
    title: "Metro Concourse Retrofit",
    description:
      "Night-shift retrofit of transit concourse with carbon-fibre wrapping, waterproofing upgrades, and new passenger circulation cores.",
    image: "/images/construction-site-3.avif",
    category: "Infrastructure Upgrades",
  },
];

export const testimonials = [
  {
    name: "Shweta Rana",
    role: "Founder & CEO",
    quote:
      "We treat every home and workspace as a story waiting to be told. Our multidisciplinary team ensures the narrative stays consistent from blueprint to handover.",
    avatar:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Vishal Rana",
    role: "Head of Management",
    quote:
      "Strong vendor partnerships, strict checklists, and responsive coordination help us deliver complex turnkey projects on time.",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Jyoti Mehta",
    role: "Principal Architect",
    quote:
      "Immersive workshops and 3D previews allow clients to visualize their spaces before we bring them to life on-site.",
    avatar:
      "https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?auto=format&fit=crop&w=400&q=80",
  },
];

export const materialExpertise = [
  {
    title: "Premium Craftsmanship",
    description: "Customized furniture, veneers, and modular joinery engineered for durability.",
    icon: MdOutlineChair,
  },
  {
    title: "Civil & Structural Works",
    description: "RCC, masonry, waterproofing, and retrofitting executed with rigorous QA processes.",
    icon: GiBrickWall,
  },
  {
    title: "Finishes & Textures",
    description: "Paints, wallpapers, cladding, and decorative plaster curated for timeless aesthetics.",
    icon: FaPalette,
  },
  {
    title: "Energy & Automation",
    description: "Lighting, HVAC, and smart controls for efficient, tech-enabled environments.",
    icon: GiEnergyArrow,
  },
];

export const ethos = [
  {
    title: "Consultation & Planning",
    description:
      "Dedicated workshops to understand design aspirations, budgets, timelines, and vastu preferences.",
  },
  {
    title: "Execution & Project Management",
    description:
      "End-to-end site coordination with strict quality audits, progress tracking, and transparent updates.",
  },
  {
    title: "Final Touch & Handover",
    description:
      "Detailed snag checks, styling, and walkthroughs to ensure every element is ready for use.",
  },
];

export const teamMembers = [
  {
    name: "Shweta Rana",
    role: "Founder & CEO",
    bio: "Visionary leader guiding the firm’s strategic growth across architecture, construction, and interiors.",
    image:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Vishal Rana",
    role: "Head of Management",
    bio: "Drives turnkey project delivery with vendor partnerships, operational excellence, and customer success.",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Jyoti",
    role: "Architect",
    bio: "Blends aesthetics with functionality, delivering vastu-aligned plans and elegant spatial narratives.",
    image:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Jitender Sharma",
    role: "Automation Specialist",
    bio: "Implements smart automation, security, and climate control systems for modern homes and offices.",
    image:
      "https://images.unsplash.com/photo-1504595403659-9088ce801e29?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Akbar Ali",
    role: "Furniture Consultant",
    bio: "Curates furniture, fixtures, and accessories that elevate aesthetics and comfort.",
    image:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=600&q=80",
  },
];

export const faqs = [
  {
    category: "Residential Construction",
    items: [
      {
        question: "What types of residential construction services do you offer?",
        answer:
          "We build custom homes, villas, duplexes, and apartments—from architectural planning and structural work to material procurement and project management.",
      },
      {
        question: "How long does it take to complete a residential project?",
        answer:
          "Timelines depend on scope and approvals, but a standard home construction typically spans 6 to 12 months with milestone-based updates.",
      },
      {
        question: "Do you help with permits and approvals?",
        answer:
          "Yes, our team assists with securing building permits, municipal approvals, and compliances required for timely project kick-off.",
      },
    ],
  },
  {
    category: "Interior Design",
    items: [
      {
        question: "Can I customize the interior design?",
        answer:
          "Absolutely. We design around your lifestyle, aesthetics, and budget with mood boards, 3D renders, and curated material palettes.",
      },
      {
        question: "Do you handle furniture and decor?",
        answer:
          "Yes, we offer turnkey furnishing including modular furniture, bespoke pieces, lighting, soft furnishings, and accessorizing.",
      },
      {
        question: "Which brands do you work with?",
        answer:
          "We partner with top brands like Hafele, Hettich, Asian Paints, Astral, and Mitsubishi for reliable quality and warranties.",
      },
    ],
  },
  {
    category: "Commercial Services",
    items: [
      {
        question: "What kinds of commercial spaces do you design?",
        answer:
          "We create interiors for offices, retail stores, restaurants, salons, clinics, hotels, co-working hubs, banks, and more.",
      },
      {
        question: "Do you offer turnkey commercial fit-outs?",
        answer:
          "Yes. We manage design, civil works, MEP services, furniture, and handover to deliver ready-to-use commercial environments.",
      },
      {
        question: "How do you ensure minimal downtime?",
        answer:
          "We operate on phased execution with extended work hours, pre-fabrication, and precise scheduling to meet tight timelines.",
      },
    ],
  },
  {
    category: "Renovation & Remodeling",
    items: [
      {
        question: "Can you handle partial renovations?",
        answer:
          "Yes, whether it is kitchen upgrades, bathroom remodeling, or complete facade refresh, we structure solutions around your needs.",
      },
      {
        question: "How do you solve damp and leakage issues?",
        answer:
          "We perform root-cause inspections, waterproofing, structural repairs, and recommend material upgrades to prevent recurring issues.",
      },
      {
        question: "Will we need to vacate during renovation?",
        answer:
          "We plan in phases to reduce disruption. For major structural changes we recommend temporary relocation for safety and speed.",
      },
    ],
  },
];

export const contactDetails = {
  address:
    "1-1-259/138, Srinivasa Nagar Colony, beside Max Show Room, Brindavan Colony, Kapra, Secunderabad, Telangana 500062, India",
  phonePrimary: "+91 70137 94781",
  phoneSecondary: "+91 70137 94781",
  email: "kaarthekeyaaconstructions@gmail.com",
  workHours: "Mon to Sat - 9:00 AM to 7:00 PM",
};

export const deliveryLocations = [
  "Delhi NCR",
  "Gurugram",
  "Noida",
  "Faridabad",
  "Ghaziabad",
  "Jaipur",
  "Lucknow",
  "Chandigarh",
];

export const enquiryServices = [
  "Architectural Design",
  "Residential Construction",
  "Residential Interiors",
  "Commercial Interiors",
  "Renovation & Remodeling",
  "Home Automation",
  "Vastu Consultation",
];

